export default {
    NODE_ENV: process.env.NODE_ENV,
    VUE_APP_BASE_API_URL: process.env.VUE_APP_BASE_API_URL,
    VUE_APP_PAYSTACK_SECRET_KEY: process.env.VUE_APP_PAYSTACK_SECRET_KEY,
    VUE_APP_GOOGLE_AUTH_CLIENT_ID: process.env.VUE_APP_GOOGLE_AUTH_CLIENT_ID,
    VUE_APP_CLIENT_URL: process.env.VUE_APP_CLIENT_URL,
};